import { accountPath } from "@/lib/utils/paths";
import React from "react";
import { Button } from "../ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import Link from "next/link";
import { cn } from "@/lib/utils/cn";
import useUserData from "@/hooks/useUserData";

interface IProps {
  type: "always-extended" | "can-shrink";
  onClick?: () => void;
}

const AccountButton = ({ type, onClick }: IProps) => {
  const { userData } = useUserData();

  if (!userData) {
    return;
  }

  return (
    <Link href={accountPath} shallow onClick={onClick}>
      <Button
        variant="secondary"
        className={cn([
          "rounded-full px-0 gap-3",
          type === "can-shrink" ? "custom-button" : "",
        ])}
      >
        {userData!.linkedinAccount && (
          <Avatar>
            <AvatarImage src={userData!.linkedinAccount.picture} />
            <AvatarFallback className="border border-foreground p-2">
              {`${userData!.linkedinAccount.given_name[0]}${
                userData!.linkedinAccount.family_name[0]
              }`}
            </AvatarFallback>
          </Avatar>
        )}
        <div
          className={cn([
            "text-start mr-3",
            type === "can-shrink" ? "hide-on-small" : "",
          ])}
        >
          <p>{userData!.linkedinAccount.name}</p>
          <p className="text-xs text-yellow-600">
            {userData!.availableTokens.toFixed(2)} tokens
          </p>
        </div>
      </Button>
    </Link>
  );
};

export default AccountButton;
